export const EXAM_RESPONSE_STATUS = {
  PASSED: 1,
  FAILED: 2,
  PENDING_EVALUATION: 3,
};
